import { useState } from "react";
import Modal from "../../components/elements/Modal";
import { ModalContext } from "./modal.context";

const ModalProvider = ({ children }) => {
  const [modals, setModals] = useState([]);

  const removeModal = (id) => {
    setModals(modals.filter((item) => item.id !== id));
  };

  return (
    <ModalContext.Provider value={{ modals, setModals }}>
      {modals.map((item) => (
        <Modal
          key={item.id}
          id={item.id}
          display={item.display}
          size={item.size}
          title={item.title}
          fullMobile={item.fullMobile}
          hiddeCloseButton={item.hiddeCloseButton}
          onClose={() => removeModal(item.id)}
          onCloseCallback={item.onCloseCallback}
          icon={item.icon}
          titleVariant={item.titleVariant}
          headerClassName={item.headerClassName}
        >
          {item.children}
        </Modal>
      ))}
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
